import PHPURL from '../reducers/ReducerPHPURL';

export function getActivitiesInDomain(domain) {

    let phpPath = PHPURL.baseURL + PHPURL.getActivitiesInDomain + domain;

    return function(dispatch) {

        fetch(phpPath)
            .then(response => response.json())
            .then(data => {
                dispatch({
                    type: "ACTIVITIES",
                    payload: data.Activities
                })
            })
            .catch((error) => {
                dispatch({
                    type: "ACTIVITIES",
                    payload: error
                })
            })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/getActivitiesInDomain.js